module.exports = __webpack_public_path__ + "static/media/wc2.27ccaa3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/photos/wc2.jpg
// module id = 215
// module chunks = 0